import { MoovStepCustomerParametersDTO } from "../DTO/moovStepCustomerParametersDTO";

export class MoovStepCustomerParameters{
    public id!: number;
    public moovStepId!: number;
    public customerId!: number;
    public parameterOptionId!: number;
    public parameters!: CustomerParameter[];

    constructor(){
        this.parameters=[];
    }

    public static mapFromDTO(param:MoovStepCustomerParametersDTO):MoovStepCustomerParameters{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovStepCustomerParameters();
        try
        {
            obj.id = param.id;
            obj.moovStepId = param.moovStepId;
            obj.customerId = param.customerId;
            obj.parameterOptionId = param.parameterOptionId;
            if(param.parameters) obj.parameters = JSON.parse(param.parameters);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovStepCustomerParameters):MoovStepCustomerParametersDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovStepCustomerParametersDTO();
        try
        {
            dto.id = param.id;
            dto.moovStepId = param.moovStepId;
            dto.customerId = param.customerId;
            dto.parameterOptionId = param.parameterOptionId;
            if(param.parameters && param.parameters.length>0) dto.parameters = JSON.stringify(param.parameters);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}

export class CustomerParameter{
    public name!: string;
    public value!: string;
}